export enum AuthActionType {
    PATIENT_LOGIN_REQUEST = 'PATIENT_LOGIN_REQUEST',
    PATIENT_LOGIN_SUCCESS = 'PATIENT_LOGIN_SUCCESS',
    PATIENT_LOGIN_FAIL = 'PATIENT_LOGIN_FAIL',
    PATIENT_PATIENT_LOGOUT_REQUEST = 'PATIENT_PATIENT_LOGOUT_REQUEST',
    PATIENT_LOGOUT_SUCCESS = 'PATIENT_LOGOUT_SUCCESS',
    PATIENT_LOGOUT_FAIL = 'PATIENT_LOGOUT_FAIL',
    PATIENT_ERROR_LOG = 'PATIENT_ERROR_LOG',
    PATIENT_CLEAR_ERROR_LOG = 'PATIENT_CLEAR_ERROR_LOG',
    PATIENT_TOGGLE_SIDEBAR = 'PATIENT_TOGGLE_SIDEBAR',
    PATIENT_CHANGE_LANGUAGE = 'PATIENT_CHANGE_LANGUAGE',
    PATIENT_FETCH_USER_DETAILS = 'PATIENT_FETCH_USER_DETAILS',
    PATIENT_STORE_MENU_DETAILS = 'PATIENT_STORE_MENU_DETAILS',
    PATIENT_PROFILE_PIC_UPDATE = 'PATIENT_PROFILE_PIC_UPDATE',
    PATIENT_PROFILE_USERNAME_UPDATE = 'PATIENT_PROFILE_USERNAME_UPDATE',
    PATIENT_SHOW_LOADER = 'PATIENT_SHOW_LOADER',
    PATIENT_UPDATE_NOTIFICATION_COUNT = 'PATIENT_UPDATE_NOTIFICATION_COUNT',
    PATIENT_UPGRADE_TO_CARE_PLAN = 'PATIENT_UPGRADE_TO_CARE_PLAN',
    PATIENT_PASSWORD_RESET = 'PATIENT_PASSWORD_RESET',
    PATIENT_UPDATE_ACCESS_TOKEN = 'PATIENT_UPDATE_ACCESS_TOKEN',
    SET_SERVICE_DOWN = 'SET_SERVICE_DOWN',
}
